import { render } from "./AttachUsersModal.vue?vue&type=template&id=8ff957fc&scoped=true"
import script from "./AttachUsersModal.vue?vue&type=script&lang=js"
export * from "./AttachUsersModal.vue?vue&type=script&lang=js"

import "./AttachUsersModal.vue?vue&type=style&index=0&id=8ff957fc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ff957fc"]])

export default __exports__